import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

export function applyHideImages(enabled) {
  toggleHtmlClass(CLASSES.hideImages, enabled);
}
